import { Observable, of, defer } from "rxjs"
import { switchMap, catchError, delayWhen } from "rxjs/operators"
import { ofType, StateObservable } from "redux-observable"
import type { EpicDependencies } from "../../../../rxjs/configureEpics"
import { getHttpHeaders } from "../../../../auth/selectors"
import { FETCH_UNMATCHED_ORDER_ITEM_NAMES_REQUESTED, fetchUnmatchedOrderItemNamesSuccess } from "../actions"
import { fetchUnmatchedOrderItemNamesApi } from "./request"
import { createActionLoadingError } from "../../../../data/actions"
import { Action, StateObject } from "../../../../redux/types"
import { waitForAccountSelected } from "../../../reports/customers/customersTable/epics"

export const fetchUnmatchedOrderItemNamesRequestedEpics = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(FETCH_UNMATCHED_ORDER_ITEM_NAMES_REQUESTED),
        delayWhen((action: Action) => waitForAccountSelected(actions$, deps.getState(), action)),
        switchMap(() => {
            return defer(() => fetchUnmatchedOrderItemNamesApi(getHttpHeaders(deps.getState()))).pipe(
                switchMap(res => {
                    if (res) {
                        return [fetchUnmatchedOrderItemNamesSuccess(res)]
                    }

                    return []
                }),
                catchError(err => of(createActionLoadingError(err)))
            )
        })
    )

export default [fetchUnmatchedOrderItemNamesRequestedEpics]
